import { render, staticRenderFns } from "./webContentV.vue?vue&type=template&id=58a6a725&scoped=true&"
import script from "./webContentV.vue?vue&type=script&lang=js&"
export * from "./webContentV.vue?vue&type=script&lang=js&"
import style0 from "./webContentV.vue?vue&type=style&index=0&id=58a6a725&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a6a725",
  null
  
)

export default component.exports